module.exports = __webpack_public_path__ + "static/media/ReportedHolrbacks.37cf2a8a.png";